export const BASE = {
  company: {
    logo: "https://storage.googleapis.com/companies-assets/sao-paulo-fc/sao-paulo-fc_20231111182624.png",
    background_image: "https://storage.googleapis.com/companies-assets/sao-paulo-fc/onboarding_sao_paulo.jpg",
    primaryColor: "#444444",
    secondaryColor: "#fe0100",
    tertiaryColor: "#541b10",
    copyrightLogo: "default",
    backgroundColor: ["#000000", "#000000"],
    tenant: 'saopaulo-oj8c8',
    name: 'São Paulo',
    bepassLogo: "https://storage.googleapis.com/companies-assets/bepass/bepass_white_logo.png",
    id: '0309214a-b846-48d7-97da-d506ac044059',
    dis: 0.87
  }
}